export default __webpack_public_path__ + "img/peugeot-logo.874a0557.png";